module.exports = __webpack_public_path__ + "static/media/flecha_back2.e60cd287.svg";